export default {
	error: {
		toast: {
			content: 'There has been a minor technical issue, please refresh the page.',
			heading: 'Unable to search',
		},
	},
	filters: {
		defaultMake: 'Make',
		defaultModel: 'Model',
		make: 'Make',
		makeAndModel: 'Make and model',
		model: 'Model',
		search: 'Search',
	},
};
